var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8C21 8 19 13.5 12 13.5C5 13.5 3 8 3 8",
    stroke: "#606473",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92332 11.9582C8.26517 12.1921 8.35269 12.6588 8.11879 13.0007L6.11901 15.9234C5.88511 16.2653 5.41837 16.3528 5.07652 16.1189C4.73466 15.885 4.64715 15.4183 4.88105 15.0764L6.88083 12.1537C7.11473 11.8118 7.58147 11.7243 7.92332 11.9582Z",
    fill: "#606473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.75C12.4142 12.75 12.75 13.0858 12.75 13.5V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V13.5C11.25 13.0858 11.5858 12.75 12 12.75Z",
    fill: "#606473"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91514 9.71111C5.10734 10.078 4.96569 10.5313 4.59877 10.7235L1.84804 12.1643C1.48111 12.3565 1.02786 12.2149 0.835657 11.848C0.643459 11.4811 0.785102 11.0278 1.15203 10.8356L3.90276 9.39474C4.26968 9.20254 4.72294 9.34418 4.91514 9.71111Z",
    fill: "#606473"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0768 11.9582C16.4186 11.7243 16.8854 11.8118 17.1193 12.1537L19.119 15.0764C19.3529 15.4183 19.2654 15.885 18.9236 16.1189C18.5817 16.3528 18.115 16.2653 17.8811 15.9234L15.8813 13.0007C15.6474 12.6588 15.7349 12.1921 16.0768 11.9582Z",
    fill: "#606473"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0849 9.71111C19.2771 9.34418 19.7304 9.20254 20.0973 9.39474L22.848 10.8356C23.215 11.0278 23.3566 11.4811 23.1644 11.848C22.9722 12.2149 22.519 12.3565 22.152 12.1643L19.4013 10.7235C19.0344 10.5313 18.8927 10.078 19.0849 9.71111Z",
    fill: "#606473"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/invisible.f08ef4d1.svg";
export { ForwardRef as ReactComponent };